

export const AdminUsers = [
  "uma.rani.battu",
  "h.srinivasan",
  "varsha.a.tyagi",
  "jeevadharani.ramanan",
  "vinod.manoharan",
  "ankur.e.mishra",
  "aayushi.bharti",
  "lavanya.umesh",
  "devika.gajanan.pote",
  "srikanth.narabathoju",
  "dhaval.atul.pantojee",
  "mahamad.h.l.pirjade"
];